// Get verify code button status (for 6 pin input)
export const getButtonStatus = (value: string): boolean => {
  if (value.length > 5) {
    return false; // Should enable button
  } else {
    return true; // Should disable button
  }
};
